<template>
    <div class="echart-line"  ref="echartsBarRef" style="height: 400px; width: 100%"></div>
</template>

<script>
import {getHomeExpenseBar} from "@/apis/public";
import * as echarts from 'echarts';
import macarons from  '@/apis/macarons'
export default {
    name: 'EchartLine',
    props : {
        search : Object
    },
    components: {

    },
    data () {
        return {
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: [],
                        axisLabel: {
                            rotate: 30 // 旋转45度
                        },
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '报销金额',
                        type: 'bar',
                        barWidth: 30,
                        data: []
                    }
                ]
            }
        }
    },
    created(){

    },
    mounted(){
        this.$nextTick(() => {
            this.getBarEchart();
        })
    },
    methods:{
      getBarEchart(){
        let that = this;
        getHomeExpenseBar().then(e=>{
          let re = e.data;
          const chartDom = this.$refs.echartsBarRef;
          echarts.registerTheme('macarons', macarons);
          const myChart = echarts.init(chartDom, macarons);
          that.option.xAxis[0].data = re.date;
          that.option.series[0].data = re.expense_money;
          myChart.setOption(that.option);
        })
      },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
